import { render } from "./HotspotLabelsButton.vue?vue&type=template&id=2fa0da30"
import script from "./HotspotLabelsButton.vue?vue&type=script&lang=js"
export * from "./HotspotLabelsButton.vue?vue&type=script&lang=js"

import "./HotspotLabelsButton.vue?vue&type=style&index=0&id=2fa0da30&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__